export const scatter = {
  lines: {
    line: {
      width: 2
    }
  },

  markers: {}
}



// WEBPACK FOOTER //
// ./src/types/scatter.js